/*
 * @Author       : 程哲林
 * @Date         : 2024-04-07 14:18:45
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-04-22 11:37:12
 * @FilePath     : /marketing-introduce-ssr/components/Activity/UserFeedback/index.tsx
 * @Description  : 未添加文件描述
 */
import { useUpdateEffect } from 'ahooks';
import { Toast } from 'antd-mobile';
import cx from 'classnames';
import React, { useState } from 'react';

import { sensClickInitiative, sensElementView } from '@/utils/sensors';

import styles from './index.module.scss';

type IProps = {
  visible: boolean;
};

const USER_FEEDBACK = 'USER_FEEDBACK';

const UserFeedback = React.memo(({ visible }: IProps): JSX.Element | null => {
  const [textContent, setTextContent] = useState('');
  const [select, setSelect] = useState(-1);
  const { id, webPageId } = __store?.actInfo || {};
  const [show, setShow] = useState(true);

  const isVisible = show && visible && !sessionStorage.getItem(USER_FEEDBACK);

  const items = ['很糟糕', '一般般', '太赞了'];

  const sens = {
    $element_name: '用户评分点击',
    $element_type: '提交评分',
    // -1 未选择，0不满意，1一般般，2满意
    custom_state: select.toString(),
    $element_content: textContent.slice(0, 100),
    activity_id: id,
    activity_label: '转介绍',
    material_id: [webPageId]
  };

  useUpdateEffect(() => {
    if (isVisible) {
      sensElementView({
        c_element_name: '用户评分弹窗',
        activity_id: id,
        activity_label: '转介绍',
        material_ids: [webPageId]
      });
    }
  }, [visible]);

  const pushFeedback = () => {
    sensClickInitiative(sens);

    setShow(false);

    sessionStorage.setItem(USER_FEEDBACK, 'close');

    Toast.show('提交成功');
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles['cp-feedback']}>
      <div className={styles.inner}>
        <div className={styles.box}>
          {items.map((txt, idx) => {
            return (
              <div
                onClick={() => {
                  setSelect(idx);
                }}
                key={txt}
                className={cx(styles.item, {
                  [styles.active]: select === idx
                })}>
                <div className={styles[`img${idx + 1}`]} />
                <span>{txt}</span>
              </div>
            );
          })}
        </div>
        {select >= 0 && select < 2 ? (
          <div className={styles.text}>
            <textarea
              value={textContent}
              onChange={(e) => {
                setTextContent(e.target.value);
              }}
              placeholder='建议不超过100字'
            />
          </div>
        ) : null}
        <button
          sensors-disable='true'
          onClick={pushFeedback}
          disabled={select < 0}
          className={styles.btn}
          type='button'>
          提交
        </button>
        <div
          onClick={() => {
            setShow(false);

            sensClickInitiative({
              ...sens,
              $element_type: '关闭'
            });
          }}
          className={styles.close}
        />
      </div>
    </div>
  );
});

export default UserFeedback;
